import styled from 'styled-components';

import { gridSizes, weights } from 'utils/style';

import FilterDates from 'components/orders/Filters/Filters/Dates/container';

export default styled(FilterDates)`
  align-items: baseline;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin: -1px 0;

  & > button:first-child {
    font-size: ${gridSizes('M')};
    font-weight: ${weights('regular')};
    color: var(--primary500);

    &:hover {
      text-decoration: none;
    }

    svg {
      margin: 0;
      fill: var(--primary500);
    }

    .btnText {
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 160px;
      overflow: hidden;
      text-align: right;
    }
  }
`;
